import { Collection } from '@appTypes/CollectionTypes'
import { ListPools } from '@components/rockpool/ListPools'
import { SearchOpenSeaNft } from '@components/rockpool/SearchOpenSeaNft'
import { DefaultPageTemplate } from '@components/shared/templates/DefaultPageTemplate'
import { rockpoolService } from '@services/RockpoolService'
import { GetServerSideProps } from 'next'
import styled from 'styled-components'
import RockpoolHeader from '../../../../components/rockpool/RockpoolHeader'

interface RockPoolPageProps {
  topCollections: Collection[]
  chainId: number
}

export default function RockPoolPage({ topCollections, chainId }: RockPoolPageProps) {
  const background = 'linear-gradient(180deg, #57313d 0%, #18181e 67%)'

  return (
    <DefaultPageTemplate background={background} header={<RockpoolHeader chainId={chainId} />}>
      <Container>
        <SearchOpenSeaNft chainId={chainId} />
        <ListPools topCollections={topCollections} chainId={chainId} />
      </Container>
    </DefaultPageTemplate>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const chainId = Number(context.params?.chainId as string) || 1

  const topCollections = await rockpoolService().getTopCollections(chainId)

  return {
    props: {
      topCollections,
      chainId
    }
  }
}

export const { Container } = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `
}
